(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ms-product-benefits"] && !Shopify.designMode) return;
  try {
    document.addEventListener('sv:variant', function(event) {
 const id = String(event.detail?.id ?? '');
 document.querySelectorAll('[data-ms-benefits] [data-ms-variant]').forEach(function(item) {
  item.hidden = item.dataset.msVariant !== id;
 });
});
  } catch(e) { console.error(e); }
})();

})();
